<template>
  <div class="tarjeta-pie">
    <div class="chart-pie-container" v-if="chartData && chartData.labels && chartData.labels.length > 0">
      <ChartPie
        :data="chartData"
        :height="240"
        :title="titulo"
      />
      <p class="chart-title">{{ titulo }}</p>
    </div>
    <div v-else class="loading-container">
      <p>Cargando gráfico...</p>
    </div>
  </div>
</template>

<script>
import ChartPie from '../Charts/ChartPie.vue';

export default {
  name: 'TarjetaPie',
  components: { ChartPie },
  props: ['color', 'icono', 'titulo', 'data', 'colorFont'],
  data() {
    return {
      chartData: null,
    };
  },
  computed: {
    tarjetaStyle() {
      return {
        backgroundColor: this.color,
        width: '100%',
        height: '100%',
      };
    }
  },
  mounted() {
    this.initializeChart();
  },
  watch: {
    data: {
      handler() {
        this.initializeChart();
      },
      deep: true
    }
  },
  methods: {
    initializeChart() {
      if (!this.data || !this.data.labels || !this.data.data) {
        return;
      }
      
      const label = this.data.label || 'Datos';
      this.chartData = {
        labels: this.data.labels,
        datasets: [
          {
            label: label,
            backgroundColor: this.data.backgroundColor,
            data: this.data.data,
            borderColor: this.data.borderColor,
            tension: 0.4,
          }
        ]
      };
    }
  }
}
</script>

<style scoped>
.tarjeta-pie {
  width: 100%;
  height: 100%;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.chart-pie-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  text-align: center;
  padding: 0.75rem;
}

.chart-pie-container canvas {
  margin: 0 auto !important;
  display: block !important;
}

.chart-title {
  color: #666;
  font-size: 0.9rem;
  font-weight: 500;
  margin-top: 0.5rem;
  margin-bottom: 0;
  text-align: center;
}

.loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #666;
  font-size: 0.9rem;
}

/* Responsive para móviles */
@media (max-width: 768px) {
  .chart-pie-container {
    padding: 0.5rem;
  }
  
  .chart-title {
    font-size: 0.8rem;
  }
}
</style>